module.exports = __webpack_public_path__ + "icons/original/small/small-b5.39e97e63457f6a5ef329ce7a1f329d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-b5.png
// module id = fZOX
// module chunks = app